<template>
  <div>
    <v-app>
      <div>
        <v-app-bar app fixed color="primary" dark height="100" flat>
          <v-app-bar-nav-icon class="mx-2">
            <v-img
              style="max-width: 70px;max-height: 70px;width: 70px;height: 70px;"
              cover
              src="./assets/CARARAMONASINFONDO.png"
            ></v-img>
          </v-app-bar-nav-icon>
          <v-toolbar-title>
            <!-- <v-row dense>
              <v-col>
                {{ nameAgent }}
              </v-col>
            </v-row> -->
            <v-row dense><v-col></v-col></v-row>
            <v-row dense><v-col></v-col></v-row>
            <v-row dense>
              <v-col class="text-subtitle-2">
                {{ $t("assistant") }}
              </v-col>
            </v-row>
            <!-- <v-row dense>
              <v-col class="text-subtitle-2">
                <span>
                  <img src="./assets/online.png" style="width: 10px; height: 10px;" />
                </span>
                {{ $t("online") }}
              </v-col>
            </v-row> -->
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon>mdi-email-outline</v-icon>
          <v-icon @click="minimizar">mdi-minus-box</v-icon>
          <v-icon @click="dialog = true">mdi-close-circle</v-icon>
        </v-app-bar>
        <v-main>
          <v-container fluid>
            <v-list class="chat-messages" ref="messageList">
              <v-row
                class="ma-1"
                :class="message.isUser ? 'justify-end':'justify-start'"
                v-for="(message, index) in messages"
                :key="index"
                :id="index">
                <v-col cols="12" md="6" :class="message.isUser ? 'sent':'received'">
                  <v-list-item style="padding: 1px;">
                    <v-list-item-content style="padding: 1px;">
                      <v-list-item-title v-html="message.user"></v-list-item-title>
                      <v-col style="padding-top: 0px; padding-bottom: 0px;" :cols="12" v-for="(msgInLine, index1) in message.message" :key="index1">
                        <v-btn block outlined color="primary" v-if="msgInLine.includes('{')"
                          @click="prepareResponse(msgInLine)">{{ msgInLine.replace("{", "").replace("}", "") }}</v-btn>
                        <div v-else>
                          <span v-html="msgInLine"></span>
                        </div>
                      </v-col>
                    </v-list-item-content>
                  </v-list-item>
                  <div class="div-flex justify-end" style="display: flex;">
                    <span class="text-caption text-right">{{ message.time }}</span>
                  </div> 
                </v-col>
              </v-row>
            </v-list>
          </v-container>
          <v-footer fixed app>
            <v-text-field 
              hide-details
              dense
              v-model="message"
              :label="$t('writeYourMessage')"
              outlined
              @keyup.enter="sendMessage">
            </v-text-field>
            <div>
              <v-icon @click="sendMessage" class="sendICon">
                mdi-send
              </v-icon>
            </div>
          </v-footer>
        </v-main>
      </div>
    </v-app>
    <v-dialog v-if="dialog"
      v-model="dialog"
      width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-btn
          color="primary"
          v-bind="props"
        >
          Open Dialog
        </v-btn>
      </template>
      <v-card>
        <v-card-text>{{ $t("outChat") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            variant="text"
            @click="dialog = false"
          >
          {{ $t("no") }}
          </v-btn>
          <v-btn
            color="error"
            variant="text"
            @click="endingWebChat"
          >
          {{ $t("yes") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { CONNECTIONSIGNALR } from "./plugins/signalR"

export default {
  name: 'App',
  data() {
    return {
      username: "",
      messages: [],
      message: "",
      dialog: false,
      nameAgent: process.env.VUE_APP_Name,
    }
  },
  methods: {
    async initChat(){
      await this.startChat()
    },
    minimizar() {
      window.parent.postMessage("minimizeChat", "*");
    },
    async startChat() {
      await CONNECTIONSIGNALR.invoke("Send_Message", "Casalimpia");
    },
    async endingWebChat() {
      await CONNECTIONSIGNALR.invoke("Send_Message", "salida");
      this.messages = [];
      this.message = "";
      this.dialog = false;
      window.parent.postMessage("endChat", "*");
    },
    proccessBold(msg) {
      let message = "";
      let reg1 = /\|\*/g;
      let reg2 = /\*\|/g;
      try {
        for(let i=0; i <= msg.length; i++) {
          msg[i] = msg[i].replace(reg1, "<b>").replace(reg2, "</b>");
        }
      } catch {
        return msg;
      }
      return message
    },
    proccessLinks(msg) {
      let message = "";
      let reg1 = /\|\-/g;
      let reg2 = /\-\|/g;
      try {
        for(let i=0; i <= msg.length; i++) {
          var mySubString = msg[i].substring(
            msg[i].indexOf("|-") + 2, 
            msg[i].lastIndexOf("-|")
          );
          msg[i] = msg[i].replace(reg1, `<a href="${mySubString}" target="_blank">`).replace(reg2, "</a>");
        }
      } catch {
        return msg;
      }
      return message
    },
    async ConnetClientHub() {
      if (CONNECTIONSIGNALR.state == "Disconnected") {
        await CONNECTIONSIGNALR.start()
        .then(() => {
          CONNECTIONSIGNALR.on("NewMSG", msg => {
            let reg = /\|\!~/g;
            let newMessage = msg.split(reg);
            let proccessMessage = this.proccessBold(newMessage);
            proccessMessage = this.proccessLinks(proccessMessage)
            this.messages.push({"user": process.env.VUE_APP_Name, "message": proccessMessage, "isUser": false, time: this.localDate()})
            this.scrollToBottom();
          });
        })
        .catch(function(err) {
          console.log(err.toString());
          // setTimeout(this.ConnetClientHub, 5000);
        });
      }
    },
    prepareResponse(msg) {
      if(msg != null|| msg != undefined|| msg != "") {
        this.message = msg.replace("{", "").replace("}", "");
      }
      this.sendMessage()
    },
    async sendMessage() {
      if (this.message != "") {
        CONNECTIONSIGNALR.invoke("Send_Message", this.message);
        this.messages.push({"user": this.$t("you"), "message": [this.message], "isUser": true, time: this.localDate()})
        this.message = "";
        this.scrollToBottom();
      }
    },
    scrollToBottom() {
      this.$nextTick( () => {
        const messageList = this.$refs.messageList.$el;
        messageList.scrollTo({top:messageList.scrollHeight, behavior: "smooth"})
      })
    },
    localDate() {
      let clock = new Date() 
      let hour =  clock.getHours() 
      let minutes = String(clock.getMinutes()).padStart(2, '0')

      return hour + ":" + minutes
    },
    receiveMessage(ev) {
      if (ev.data === "startChat") {
        this.startChat()
      }
    }
  },
  async mounted() {
    let userLang = navigator.language || navigator.userLanguage;
    switch(userLang.substring(0, 2)) {
      case 'en': 
        this.$root.$i18n.locale = 'en';
        break;
      case 'pt':
        this.$root.$i18n.locale = 'pt';
        break;
      case 'es':
        this.$root.$i18n.locale = 'es';
        break;
      default:
        this.$root.$i18n.locale = 'en';
        break;
    }
    
    window.addEventListener('message', this.receiveMessage);
    
    await this.ConnetClientHub();
  },

}
</script>

<style>
.message {
  display: inline-block;
  padding: 5px;
  border-radius: 5px;
  margin: 5px 0;
  max-width: 50%;
}
.sent {
  background-color: #8ec5ff;
  color: white;
  border-radius: 10px;
  padding: 1px;
}
.received {
  background-color: #f2f2f2;
  color: black;
  border-radius: 10px;
  padding: 1px;
}

.chat-messages {
  height: calc(100vh - 100px);
  overflow-y: auto;
  z-index: 1;
}
.chat-input {
  position: fixed;
  bottom: 0px;
  width: 98%;
  background-color: #f5f5f5;
  border-top: 1px solid #ccc;
}
.sendICon {
  display: block;
  font-size: 3em;
  color: #1976d2;
  cursor: pointer;
  margin-left: 10px;
  transition: all 300ms linear;
}

.sendICon:hover {
  color: #0e3a66;
}
</style>
